





































import { Component, Prop, Vue } from 'vue-property-decorator'
import Modal from '@/components/Modal.vue'
import LoginForm from '@/components/LoginForm.vue'

@Component({
	components: {
		Modal,
		LoginForm,
	},
})
export default class SwitchAccount extends Vue {
	private clientList: object[] = JSON.parse(localStorage.clientList) || []
	private currentClient: string = localStorage.client || ''
	private showModal: boolean = false

	private switchAccount(account) {
		if (this.currentClient === account.client) {
			return
		}
		localStorage.setItem('client', account.client)
		localStorage.setItem('authKey', account.authKey)
		this.$store.dispatch('initialFetch').then(() => {
			this.$router.push({ name: 'home' })
		}, (error: any) => {
			this.$toasted.error('Failed to switch accounts')
		}).finally(() => {
			this.refreshStorageProperties()
		})
	}

	private removeAccount(account) {
		const accountIndex = this.clientList.indexOf(account)
		if (accountIndex < 0) {
			return
		}
		this.clientList.splice(accountIndex, 1)
		localStorage.setItem('clientList', JSON.stringify(this.clientList))
	}

	private addAccount(login) {
		this.$store.dispatch('login', login).then(() => {
			this.$store.dispatch('initialFetch')
		}, (error: any) => {
			this.$toasted.error('Failed to add account')
		}).finally(() => {
			this.refreshStorageProperties()
		})
	}

	private refreshStorageProperties() {
		const jsonClientList: any = localStorage.getItem('clientList')
		this.clientList = JSON.parse(jsonClientList) || []
		this.currentClient = localStorage.getItem('client') || ''
	}
}
